(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-mini-cart-content"] && !Shopify.designMode) return;
  try {
    class CartNote extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('change', (event) => {
			event.stopPropagation();

			debounce((event) => {
				const body = JSON.stringify({ note: event.target.value });
				fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
			}, 300)(event);
		})
	}
}

customElements.define('cart-note', CartNote);
  } catch(e) { console.error(e); }
})();

})();
